import Services from './base-services'

const service = new Services('skinFavorite')
import mapParameters from '../utils/map-parameters'

export default {
    getAllByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllByUser', params)
    },
    createFavorite(userId: number|string, skinId: number|string) {
        const params = {
            user: {
                id: userId
            },
            skin: {
                id: skinId
            }
        }
        return service.post('createFavorite', params)
    },
    deleteFavorite(userId: number|string, skinId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null,
            skinId: skinId ? skinId : null
        })
        return service.delete('deleteFavorite', params)
    }
}
